<template>
  <!-- 心法 -->
  <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }">
    <p slot="title">心法</p>
    <div slot="extra"></div>
    <div>
      <div style="overflow: hidden; margin-bottom: 15px">
        <div class="activeSkill">
          <h4>主动神通</h4>
          <div  class="skillList"
            v-for="(item, index) in activeList"
            :key="index"
            style="margin-bottom: 4px"
          >
            <!-- <span>{{ item.skillName }}:</span> -->
            <Poptip
              trigger="hover"
              :title="item.skillName"
              width="400"
              word-wrap
            >
              <p style="white-space: nowrap; height: 24px" >
                <span :style="{ color: distinguishColor(item.shenxiao) }">{{ item.skillName }} {{ item.shenxiao != null ? "(已生效)" : "(未生效)"  }}</span>
<!--                <Button
                  @click.prevent="TakeSkill(item, 1)"
                  size="small"
                  type="info" ghost
                >
                  脱下
                </Button>-->
              </p>
              <div slot="content">
                <p>神通效果: {{ item.skillDesc }}</p>
              </div>
            </Poptip>
          </div>
        </div>
        <div class="passiveSkill">
          <h4>被动神通</h4>
          <div  class="skillList"
            v-for="(item, index) in passiveList"
            :key="index"
            style="margin-bottom: 4px"
          >
            <Poptip
              width="400"
              word-wrap
              trigger="hover"
              :title="item.skillName"
            >
              <p style="white-space: nowrap; height: 24px">
                <span :style="{ color: distinguishColor(item.shenxiao) }">{{ item.skillName }} {{ item.shenxiao != null ? "(已生效)" : "(未生效)"  }}</span>
<!--                <Button-->
<!--                  @click.prevent="TakeSkill(item, 2)"-->
<!--                  size="small"-->
<!--                  type="info" ghost-->
<!--                >-->
<!--                  脱下-->
<!--                </Button>-->
              </p>
              <div slot="content">
                <p>神通效果: {{ item.skillDesc }}</p>
              </div>
            </Poptip>
          </div>
        </div>
      </div>
      <div class="skillList">
        <Poptip
          width="400"
          word-wrap
          trigger="hover"
          v-for="item in skillList"
          :key="item.skillId"
          :title="item.skillName"
        >
          <p
            style="white-space: nowrap; height: 24px;margin: 3px 0"
            :style="{ color: item.color }"
          > <span> <Tag color="default" size="24">加成</Tag></span>
          {{ item.xinfaDesc }}
            <!--   <Button @click.prevent="skillEquip(item)" size="small" type="info" ghost>
               装备
             </Button>
             <Button @click.prevent="upgrade(item)" size="small" type="info" >
               升级
             </Button>-->
          </p>
          <div slot="content">
            <!-- <p>{{ item.skillName }}</p> -->
            <p style="color: #00adff">神通效果: {{ item.skillDesc }}</p>
          </div>
        </Poptip>
      </div>
    </div>
  </Card>
</template>

<script>
export default {
  name: "skill",
  data() {
    return {
      activeList: [], // 穿戴的主动神通列表
      weaponType: null,
      isActive:false, // 切换主体
      passiveList: [], // 穿戴的被动神通列表
      skillList: [], // 全部神通
    };
  },
  created() {
    this.getAllSkill();
    const theme = window.localStorage.getItem("isTheme");
    if(theme === "black"){
      this.isActive=true;
    }else{
      this.isActive=false;
    }
    //this.getAllSkill();
    //this.getEquipmentSkill();
  },
  mounted() {
    this._onThemeChanged = (theme) => {
      this.isActive = theme === "black";
    };
    this.$bus.$on("themeChanged", this._onThemeChanged);
    this.$bus.$on("getSkillMsg", () => {
      this.getAllSkill();
    });
  },
  beforeDestroy() {
    if (this._onThemeChanged) {
      this.$bus.$off("themeChanged", this._onThemeChanged);
    }
    this.$bus.$off("getSkillMsg");
  },
  methods: {
    // 获取角色的心法神通列表
    getAllSkill() {
      this.$http
        .post(
          "gameSect/getDisXinfaSkillList/?charaId=" + this.getCookie("charaId")
        )
        .then((res) => {
          const list = res.data.data;
          this.activeList = [];
          this.passiveList = [];
          this.skillList = [];
          this.weaponType = this.$store.state.weaponType;
          console.log('武器类型'+this.weaponType)
          for (let i = 0; i < list.length; i++) {
            //判断武器是否生效
            if(list[i].weaponType ===  this.weaponType){
              list[i].shenxiao=3;
            }else{
              list[i].shenxiao=1;
            }
            if(list[i].xkType == 3 ){
              this.activeList.push(list[i]);
            }
            if(list[i].xkType == 2 ){
              this.passiveList.push(list[i]);
            }
            if(list[i].xkType == 1 ){
              this.skillList.push(list[i]);
            }
          }
        })
    },
    distinguishColor(color) {
      if (color == 1) {
        return "#000";
      } else if (color == 2) {
        return "#c5c52f";
      } else if (color == 3) {
        return "#049c04";
      } else if (color == 4) {
        return "#005aff";
      } else if (color == 5) {
        return "#ff00e0";
      } else if (color == 6) {
        return "#ff0000";
      } else {
        return "#ff00c3e0";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 神通栏 */
.activeSkill {
  float: left;
  width: 50%;
  text-align: center;
}
.passiveSkill {
  float: right;
  width: 50%;
  text-align: center;
}

/* 神通列表 */
.skillList /deep/ .ivu-poptip-popper {
  pointer-events: none;
}
/*.skillList /deep/ .ivu-poptip {
  width: 50%;
}*/
.skillList /deep/ .ivu-poptip p button {
  display: none;
  height: 22px;
}
.skillList /deep/ .ivu-poptip p:hover {
  z-index: 9;
  position: relative;
}
.skillList /deep/ .ivu-poptip p:hover button {
  display: inline-block;
}
.blackBackGroup{
  background-color: #151728;
  border: none;
  color: #9c9cab;
}
.blackBackGroup .ivu-card-head p, .ivu-card-head-inner{
  color: #4975d4;
}
.blackBackGroup span{
  background-color: #151728;
  color: #9c9cab;
}
.blackBackGroup2{

}
</style>



// WEBPACK FOOTER //
// src/components/xinfaSkill.vue